export default __webpack_public_path__ + "static/media/CWA-long.77d4f147.png";